// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"d60d8836","147":"e01b3a1a","255":"7d261ec0","666":"def67f4b","748":"57a6a8e1","875":"7fe5fc47","944":"5ef5622e"}[chunkId] + ".chunk.js";
};